import { delegateEventListener } from "@oddcamp/js-utils/src/event"

delegateEventListener(`.js--share-bar-link-copy`, `click`, (e, targetEl) => {
  // use this polyfill if wider browser support is needed:
  // https://www.npmjs.com/package/clipboard-polyfill
  if (navigator.clipboard) {
    navigator.clipboard.writeText(targetEl.dataset.url)
  }
})
